// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const TOGETHER_MODELS = {
	"MiniMaxAI/MiniMax-M2.7": {
		id: "MiniMaxAI/MiniMax-M2.7",
		name: "MiniMax-M2.7",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"MiniMaxAI/MiniMax-M3": {
		id: "MiniMaxAI/MiniMax-M3",
		name: "MiniMax-M3",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 524288,
		maxTokens: 250000,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen2.5-7B-Instruct-Turbo": {
		id: "Qwen/Qwen2.5-7B-Instruct-Turbo",
		name: "Qwen 2.5 7B Instruct Turbo",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32768,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-235B-A22B-Instruct-2507-tput": {
		id: "Qwen/Qwen3-235B-A22B-Instruct-2507-tput",
		name: "Qwen3 235B A22B Instruct 2507 FP8",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-397B-A17B": {
		id: "Qwen/Qwen3.5-397B-A17B",
		name: "Qwen3.5 397B A17B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 130000,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-9B": {
		id: "Qwen/Qwen3.5-9B",
		name: "Qwen3.5 9B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 0.17,
			output: 0.25,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.6-Plus": {
		id: "Qwen/Qwen3.6-Plus",
		name: "Qwen3.6 Plus",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 500000,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.7-Max": {
		id: "Qwen/Qwen3.7-Max",
		name: "Qwen3.7 Max",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1.25,
			output: 3.75,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 500000,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-V4-Pro": {
		id: "deepseek-ai/DeepSeek-V4-Pro",
		name: "DeepSeek V4 Pro",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":true,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"high","xhigh":null},
		input: ["text"],
		cost: {
			input: 1.74,
			output: 3.48,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 512000,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
	"essentialai/Rnj-1-Instruct": {
		id: "essentialai/Rnj-1-Instruct",
		name: "Rnj-1 Instruct",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32768,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"google/gemma-4-31B-it": {
		id: "google/gemma-4-31B-it",
		name: "Gemma 4 31B Instruct",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 0.39,
			output: 0.97,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"meta-llama/Llama-3.3-70B-Instruct-Turbo": {
		id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
		name: "Llama 3.3 70B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1.04,
			output: 1.04,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2.6": {
		id: "moonshotai/Kimi-K2.6",
		name: "Kimi K2.6",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 1.2,
			output: 4.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131000,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2.7-Code": {
		id: "moonshotai/Kimi-K2.7-Code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"nvidia/nemotron-3-ultra-550b-a55b": {
		id: "nvidia/nemotron-3-ultra-550b-a55b",
		name: "Nemotron 3 Ultra 550B A55B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 0.6,
			output: 3.6,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 512300,
		maxTokens: 512300,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-120b": {
		id: "openai/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":true,"maxTokensField":"max_tokens","thinkingFormat":"openai","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null},
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-20b": {
		id: "openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":true,"maxTokensField":"max_tokens","thinkingFormat":"openai","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null},
		input: ["text"],
		cost: {
			input: 0.05,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5": {
		id: "zai-org/GLM-5",
		name: "GLM-5",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 1,
			output: 3.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5.1": {
		id: "zai-org/GLM-5.1",
		name: "GLM-5.1",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5.2": {
		id: "zai-org/GLM-5.2",
		name: "GLM-5.2",
		api: "openai-completions",
		provider: "together",
		baseUrl: "https://api.together.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"together","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 164000,
	} satisfies Model<"openai-completions">,
} as const;
